
import * as ChartJS from '$node/chart.js/dist/chart.esm.js'

window['chart.js'] = ChartJS

export * from '$node/chart.js/dist/chart.esm.js'
export * from '$node/chart.js/dist/helpers.esm.js'
